<label [for]="id" [ngClass]="['control-label', _labelClass]">Parc {{ _mandatory? '*' : '' }}:</label>
<div [ngClass]="_fieldClass">
	<filterable-select
		[id]="id"
		[disabled]="disabled"
		[inputClass]="'form-control'"
		[list]="availableParcs"
		[labelGetter]="getParcName"
		[(selectedItem)]="selectedParc"
		(selectedItemChange)="onParcSelected(); onParcChange();"
		>
	</filterable-select>
</div>